import styles from "./ChatMessage.module.css";
import avatarFallback from "../../assets/chat/perfil-sem-foto.jpeg";
import { useGeolocation } from "../../hooks/useGeolocation";

/**
 * Mensagem recebida que cita a cidade do visitante (detectada pelo IP).
 *
 *   <ChatMessageLocation textBefore="Estou em" textAfter=" e queria te ver" />
 *
 * Por padrão a cidade aparece borrada (blurCity). Use blurCity={false}
 * para mostrar em claro.
 */
export default function ChatMessageLocation({
  textBefore = "Casa de",
  textAfter = "",
  reaction = null,
  showAvatar = true,
  blurCity = true,
}) {
  const { city, loading } = useGeolocation();
  const cityText = loading ? "..." : city;

  return (
    <div className={`${styles.igMessage} ${styles.igMessageOther}`}>
      <img
        src={avatarFallback}
        alt=""
        className={`${styles.igMessageAvatar} ${!showAvatar ? styles.igMessageAvatarHidden : ''}`}
      />

      <div className={styles.igMessageBubbleContainer}>
        <div className={`${styles.igMessageBubble} ${styles.igMessageBubbleOther}`}>
          {textBefore}{" "}
          <span className={blurCity ? styles.blurWord : undefined}>{cityText}</span>
          {textAfter}
        </div>

        {reaction && (
          <div className={styles.igMessageReaction}>
            {reaction}
          </div>
        )}
      </div>
    </div>
  );
}
